import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  buttonsBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 2),
  },
}))

export default styles
